// 列表组件需要的数据
export const OPTHINES = {
  voteName: '2020project/2020doctor',
  mustSearch: 'Button',
  number: {
    mustRank: true,
  },
  listData: {
    type: 'com',
  },
  themeColor: {
    activeBgColor: '#278b09',
    inactiveBgColor: '#fff',
  },
  buttonBg: {
    backgroundColor: '',
  },
};
